module.exports = __webpack_public_path__ + "static/media/TreeM.dc63e8a1.png";